/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function o(r,u){r.forEach(r=>{u(r),"building-group"===r.type&&o(r.sublayers,u)})}export{o as forEachBuildingSublayer};
